import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const TransactionsPage = lazy(() => import('@/pages/transactions'));

export const Route = createFileRoute('/transactions')({
  component: function TransactionsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <TransactionsPage />
      </Suspense>
    );
  },
});
